/**
 * Send Acesso — shared "enviar acesso" action (senha nova por e-mail,
 * WhatsApp e notificação — Core\Services\Acesso_Envio, máx. 2/h por pessoa).
 *
 * Reused by equipe (gerenciar-equipe, resource list/single) and alunos
 * (turmas, resource list/single) screens: opens a confirm popup with a
 * lazily-loaded (compact) history of previous sends for the target user,
 * POSTs to the given REST endpoint on confirm, then shows the generated
 * reset link with a copy action (fallback in case the email link doesn't
 * work).
 *
 * @global window.lbSendAcesso
 * @package Labead
 */

(function () {
	'use strict';

	function escapeHtml(str) {
		return String(str == null ? '' : str)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}

	/** Compact one-liner: "07/07/2026 às 19:02 por Fulano"; nome completo e e-mail na dica (data-lb-dica). */
	function buildHistoryItemHtml(it) {
		var actor = it.actor || {};
		var firstName = escapeHtml(actor.first_name || actor.name || 'Alguém');
		// Dica única da plataforma (lb-flutuante.js): fica dentro da tela e abre ao tocar no celular.
		var dica = escapeHtml([actor.name || actor.first_name || '', actor.email || ''].filter(Boolean).join('\n'));
		var when = escapeHtml(it.created_at_short || '');

		return '<div class="lw:flex lw:items-center lw:gap-1 lw:mt-1 lw:text-xs">'
			+ '<span>' + when + ' por</span>'
			+ '<span class="lw:inline-block lw:cursor-help lw:border-b lw:border-dotted lw:border-current lw:font-medium"'
			+ (dica ? ' data-lb-dica="' + dica + '" data-lb-dica-toque' : '') + '>'
			+ firstName
			+ '</span>'
			+ '</div>';
	}

	/** Fetch and paint the compact "previous sends" history inside the popup placeholder. */
	async function loadSendAcessoHistory(histId, userId) {
		if (!document.getElementById(histId)) return;
		try {
			var qs = 'type=users&type_id=' + encodeURIComponent(userId)
				+ '&actions[]=send_acesso_equipe&actions[]=send_acesso_aluno&per_page=5';
			var res = await fetch(lb_data.rest_url + 'labead/v1/logbook?' + qs, {
				headers: { 'X-WP-Nonce': lb_data.rest_nonce },
			});
			var data = await res.json();
			var items = (data && data.items) || [];
			var target = document.getElementById(histId);
			if (!target) return; // popup already closed

			if (!items.length) {
				if (window.lbMascote && window.lbMascote.vazio) {
					target.innerHTML = window.lbMascote.vazio({ titulo: 'Nenhum envio anterior ainda.', icone: 'send' });
				} else {
					target.textContent = 'Nenhum envio anterior ainda.';
				}
				return;
			}

			target.innerHTML = '<div class="lw:font-medium">Histórico de envios:</div>'
				+ items.map(buildHistoryItemHtml).join('');

			if (window.lbLucide && window.lbLucide.refresh) window.lbLucide.refresh();
		} catch (e) {
			var target2 = document.getElementById(histId);
			if (target2) target2.textContent = '';
		}
	}

	/**
	 * Trigger the "enviar email com link de acesso" flow.
	 *
	 * @param {Object} opts
	 * @param {string} opts.url    REST endpoint (POST) that sends the email + logs the action.
	 * @param {number} opts.userId Target user ID (used only to load history).
	 * @param {Object} [opts.body] Optional JSON body to send with the POST (e.g. { post_key: 'alunos' }).
	 * @return {Promise<boolean>} Whether the action was confirmed and sent successfully.
	 */
	window.lbSendAcesso = async function (opts) {
		var url = opts.url;
		var userId = opts.userId;
		var body = opts.body || null;
		var histId = 'lb-send-acesso-hist-' + Date.now();

		// lbAlert.confirm() inserts the dialog into the DOM synchronously
		// before the promise resolves, so we can start loading the history
		// right after calling it (lazy-load into the placeholder above).
		var confirmPromise = lbAlert.confirm({
			color: 'b',
			html: '<h4>Enviar acesso</h4>'
				+ '<p>Uma senha nova será criada e enviada por e-mail, WhatsApp e notificação. A senha atual deixa de funcionar.</p>'
				+ '<p class="lw:text-xs lw:opacity-80">Para não encher o celular da pessoa, são no máximo 2 envios por hora.</p>'
				+ '<div id="' + histId + '" class="lb-send-acesso-history lw:text-xs lw:opacity-70 lw:mt-3 lw:text-left">'
				+ 'Carregando histórico…</div>',
			confirmButtonText: 'Criar senha e enviar',
		});

		loadSendAcessoHistory(histId, userId);

		var confirmed = await confirmPromise;
		if (!confirmed.isConfirmed) return false;

		var headers = { 'X-WP-Nonce': lb_data.rest_nonce };
		var fetchOpts = { method: 'POST', headers: headers };
		if (body) {
			headers['Content-Type'] = 'application/json';
			fetchOpts.body = JSON.stringify(body);
		}

		var data;
		try {
			var res = await fetch(url, fetchOpts);
			data = await res.json();
		} catch (e) {
			lbAlert.toast({ color: 'd', message: 'Erro ao enviar o acesso.' });
			return false;
		}

		if (!data.success) {
			lbAlert.toast({ color: 'd', message: data.message || 'Erro ao enviar o acesso.' });
			return false;
		}

		var d = data.data || {};
		var dados = '';
		if (d.senha) {
			var texto = 'E-mail: ' + (d.email || '') + '\nSenha: ' + d.senha + (d.link ? '\n' + d.link : '');
			dados = '<p class="lw:text-xs lw:mt-2">Se precisar passar para a pessoa por outro meio:</p>'
				+ '<p class="lw:text-sm lw:mt-1 lw:mb-1.5"><strong>E-mail:</strong> ' + escapeHtml(d.email || '') + '<br><strong>Senha:</strong> <code>' + escapeHtml(d.senha) + '</code></p>'
				+ '<a href="javascript:void(0)" lb-copy="' + escapeHtml(texto) + '" class="lw:inline-flex lw:items-center lw:gap-1 lw:text-xs lw:font-medium lw:no-underline lw:hover:underline lw:cursor-pointer">'
				+ '<i data-lucide="copy" class="lw:w-3 lw:h-3"></i> Copiar dados de acesso</a>';
		}
		var successPromise = lbAlert.confirm({
			color: 's',
			showCancelButton: false,
			confirmButtonText: 'Fechar',
			html: '<h4>Acesso enviado!</h4>'
				+ '<p>' + escapeHtml(data.message || '') + '</p>'
				+ dados,
		});

		if (window.lbLucide && window.lbLucide.refresh) window.lbLucide.refresh();
		await successPromise;

		return true;
	};
})();
